import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LeftPanel from './LeftPanel';

// pages
import DatabaseHome from '../pages/DatabaseHome';
import Suggest from '../pages/Suggest';
import StructureEditor from '../pages/StructureEditor';
import Login from '../pages/admin-mode/Login';
import AdminHome from '../pages/admin-mode/AdminHome';

import ProtectedRoutes from './database/admin-mode/ProtectedRoutes';

export default function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate replace to="/database" />} />
                <Route path="/database" element={<LeftPanel content={<DatabaseHome />} />} />
                <Route path="/suggest" element={<LeftPanel content={<Suggest />} />} />
                <Route path="/editor" element={<LeftPanel content={<StructureEditor />} />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoutes element={<AdminHome />}/>}></Route>
            </Routes>
        </BrowserRouter>
    );
}
